import React, { Component } from 'react';
import { Grid, Button } from '@material-ui/core';
import SelectCustom from '../../common/components/input/SelectCustom';
import ColumnsListDropdown from '../../common/components/ColumnsListDropdown';
import { observer } from 'mobx-react';
import AppStore from '../../AppStore';
import ExtractDataDialog from '../layouts/ExtractDataDialog';

export const VALUE_FIELDS = [
  { name: "Subject", value: "subject" },
  { name: "Body", value: "body" },
  { name: "From Email", value: "from" },
  { name: "To Email", value: "to" }
];
class ColumnField extends Component {
  handleChange = (val, type) => {
    let props = this.props,
      data = {
        column: props.value.column,
        value: props.value.value,
      };
    data[type] = val;
    props.onChange(data);
    if (type == "value" && (val.value == "extract-body" || val.value == "extract-subject" || val.value == "extract-body-multiple-rows")) {
      this.showExtractFromTemplateDialog(data['column'], data['value']);
    }
  };

  handleTemplateChange = (key, value) => {
    this.props.onTemplateChange(value, key)
  }

  handleTemplateSelectionChange = (key, value) => {
    this.props.onTemplateSelectionChange(key, value)
  }

  showExtractFromTemplateDialog = (column, value) => {
    let me = this,
      props = me.props,
      type,
      template;

    column = column || props.value.column;
    value = value || props.value.value;
    type = (value.value == "extract-body" || value.value == "extract-body-multiple-rows") ? "template" : "subject_template";
    template = type == "template" ? props.template : props.subjectTemplate;

    AppStore.renderDialogWithoutStore(ExtractDataDialog, {
      onChange: me.handleTemplateChange.bind(me, type),
      onSelectionChange: me.handleTemplateSelectionChange.bind(me),
      template: template,
      templateSelections: props.templateSelections,
      column: column,
      isMultipleRows: value.value == "extract-body-multiple-rows",
      multipleRowsData: props.multipleRowsData,
      onMultipleRowsDataChange: props.handleMultipleRowsDataChange
    })
  }

  getFields = () => {
    let fields = [
      { name: "Extract from body", value: "extract-body" },
      { name: "Extract from body - multiple rows", value: "extract-body-multiple-rows" },
      { name: "Subject", value: "subject" },
      { name: "Extract from subject", value: "extract-subject" },
      { name: "Body", value: "body" },
      { name: "From Email", value: "from" },
      { name: "Date", value: "date" },
      { name: "To Email", value: "to" },
    ];

    if (!this.props.isMultipleRows) {
      fields.splice(1, 1);
    }

    return fields;
  }

  getFieldCmp () {
    let me = this,
      value = me.props.value.value;

    if (!value || !value.value) {
      return "";
    }

    switch (value.value) {
      case "extract-body":
      case "extract-subject":
      case "extract-body-multiple-rows":
        return (
          <Grid item xs={2}>
            <Button onClick={() => this.showExtractFromTemplateDialog()} color="primary">
              edit
            </Button>
          </Grid>
        );
      default: return "";
    }
  }

  render () {
    let props = this.props,
      column = props.value.column,
      value = props.value.value;

    return (
      <Grid item container
        direction="row"
        justify="center"
        alignItems="center"
        spacing={3}
      >
        <Grid item xs={4}>
          <ColumnsListDropdown
            value={column}
            columns={props.columns}
            onChange={(val) => { this.handleChange(val, "column") }}
          />
        </Grid>

        <Grid item container
          direction="row"
          justify="center"
          alignItems="center"
          xs>
          <Grid item xs>
            <SelectCustom
              value={value}
              values={this.getFields()}
              onChange={(val) => { this.handleChange(val, "value") }}
              shouldForwardEvent={false}
            />
          </Grid>
          {this.getFieldCmp()}
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="outlined"
            color="primary"
            onClick={props.onDelete}
          >
            -
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default observer(ColumnField);
